import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function KidsTaekwondoHeroForm() {
  return <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-subtle-gray aspect-[4/5]" data-id="element-2197">
      <img src="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Discover%20the%20Perfect%20Program%20for%20Your%20Mini%20Trooper.png" alt="Storm Taekwondo Training" className="block w-full h-full object-cover" data-id="element-2198" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/95 via-ink/40 to-transparent" data-id="element-2199" />
      <div className="absolute bottom-0 left-0 right-0 p-8 flex flex-col gap-4" data-id="element-2200">
        <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide w-fit" data-id="element-2201">
          Find the Right Kids Class
        </div>
        <h3 className="text-3xl text-white m-0 leading-tight" data-id="element-2202">
          Ready to get started?
        </h3>
        <Link to="/SignMeUp" className="btn-primary w-full text-center" data-id="element-2203">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="text-white font-bold text-center hover:text-storm-red transition-colors flex items-center justify-center gap-2" data-id="element-2204">
          <Phone className="w-4 h-4" data-id="element-2205" />
          Or call 517-220-0621
        </a>
      </div>
    </div>;
}